import React from 'react'
import DocumentList from '../../Component/reusable_components/documents_list.js'
import { IMAGE_BASE_PATH_DBRALC } from '../../Config/Config'
import nonstatutorycommitteesData from '../../Assets/JSON/Committees/nonstatutorycommittees.json'

const NonStatutorycommitteesData = () => {
  return (
    <DocumentList
      data={nonstatutorycommitteesData}
      title="Non Statutory Committees"
      basePath={IMAGE_BASE_PATH_DBRALC}
      navigatePath="/nonstatutorycommittees"
    />
  )
}

export default NonStatutorycommitteesData
